import Moxcar_Dynamic_Scroll from '../../../library/utilities/dynamic/moxcar_scroll';
import '../scss/app.scss'; // Importing SCSS file
import {html, render} from 'lit-html';


let adoption_link = document.querySelector('.x-anchor.x-anchor-menu-item.m5-14.m5-15.m5-16.m5-17.m5-19.m5-1a.m5-1d.m5-1e.m5-1f.m5-1h.m5-1j.m5-1m.m5-1p.m5-1u.m5-1z.m5-20');

const faq_arrows = [...document.querySelectorAll('.arrow-down-svgrepo-com')];
 
faq_arrows.forEach((arrow) => { 

    arrow.onclick = function () {
     let parent = arrow.closest('.faq');
        
    parent.classList.toggle('active');
      
    }
});
 
 if(adoption_link){
    // add classlist of young-williiams-adopt-button
    adoption_link.classList.add('young-williams-adopt-button');
    
 }
 
 // pet card template


let pet_grid = document.querySelector('#petGrid');
const pet_card_template = document.getElementById('pet-card-template');
 
 
let current_url = window.location.href;
let return_element ;

const initial_pet_batch_size = 12;
const pagination_batch_size = typeof pagination_count !== 'undefined' ? pagination_count : 8;
const pet_filter_panel = document.querySelector('[data-pet-filter-panel]');
const pet_filter_results = document.querySelector('[data-filter-results-count]');
const pet_empty_state = document.querySelector('[data-pet-empty-state]');
const clear_filters_button = document.querySelector('[data-clear-filters]');
const pet_filter_toggle_buttons = [...document.querySelectorAll('[data-filter-toggle]')];
const pet_filter_sections = [...document.querySelectorAll('[data-filter-panel]')];
const pet_filter_context = window.pet_filter_context || {};

function getAnimalApiNonce(card = null) {
    const sources = [
        window.animal_api_nonce,
        card?.dataset?.animalApiNonce,
        card?.closest?.('[data-animal-api-nonce]')?.dataset?.animalApiNonce,
        document.querySelector('[data-animal-api-nonce]')?.dataset?.animalApiNonce,
        document.querySelector('[data-pet-filter-panel]')?.dataset?.animalApiNonce,
        window.pet_filter_context?.animal_api_nonce,
    ];

    for (const source of sources) {
        if (typeof source === 'string' && source.trim()) {
            return source.trim();
        }
    }

    return '';
}

async function refreshAnimalApiNonce(card = null) {
    const nonce_url = `${app.site_url}/wp-json/animal-api/v1/load-pets-nonce`;
    const response = await fetch(nonce_url, {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
    });

    if (!response.ok) {
        throw new Error('Nonce refresh failed');
    }

    const data = await response.json();
    const nonce = typeof data?.nonce === 'string' ? data.nonce.trim() : '';

    if (!nonce) {
        throw new Error('Nonce refresh returned an empty nonce');
    }

    window.animal_api_nonce = nonce;

    if (card) {
        card.setAttribute('data-animal-api-nonce', nonce);
    }

    if (pet_grid) {
        pet_grid.setAttribute('data-animal-api-nonce', nonce);
    }

    return nonce;
}

async function loadPetDetails(api_url, id, pet_status, animal_api_nonce) {
    const body = new URLSearchParams({
        ID: id,
        pet_status: pet_status,
        _ywnonce: animal_api_nonce,
    });

    return fetch(api_url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-YW-Animal-Nonce': animal_api_nonce,
        },
        body,
    });
}

let pet_scroll_loader = null;
let filtered_pet_posts = [];

const filter_state = {
    ageGroup: 'all',
    size: 'all',
    location: 'all',
    goodWithDogs: false,
    goodWithCats: false,
    goodWithKids: false,
};

function escapeHtml(value) {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function normalizePetValue(value) {
    if (Array.isArray(value)) {
        return value
            .map((item) => normalizePetValue(item))
            .filter(Boolean)
            .join(', ');
    }

    if (value === null || value === undefined) {
        return '';
    }

    return String(value).trim();
}

function normalizeCompatibilityText(value) {
    return normalizePetValue(value)
        .toLowerCase()
        .replace(/&amp;/g, ' and ')
        .replace(/[^a-z0-9]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}

function isTruthyApiFlag(value) {
    if (Array.isArray(value)) {
        return value.length > 0 && value.some((item) => normalizePetValue(item).length > 0);
    }

    if (typeof value === 'boolean') {
        return value;
    }

    if (typeof value === 'number') {
        return value > 0;
    }

    const normalized = normalizePetValue(value).toLowerCase();

    if (!normalized) {
        return false;
    }

    return ['y', 'yes', 'true', '1', 'on'].includes(normalized);
}

function uniqueValues(values) {
    return [...new Set(values.filter(Boolean))];
}

function sortAlpha(values) {
    return [...values].sort((a, b) =>
        prettyLabel(a).localeCompare(prettyLabel(b), undefined, {
            sensitivity: 'base',
        })
    );
}

function sortAgeGroups(values) {
    const order = {
        Puppy: 1,
        Kitten: 2,
        Adult: 3,
        Senior: 4,
    };

    return [...values].sort((a, b) => {
        const aRank = order[prettyLabel(a)] ?? 99;
        const bRank = order[prettyLabel(b)] ?? 99;
        return aRank - bRank;
    });
}

function prettyLabel(value) {
    return normalizePetValue(value)
        .replace(/\s+/g, ' ')
        .trim();
}

function getPetSpeciesSlug() {
    const species = prettyLabel(
        pet_filter_context.species
        || pet_filter_panel?.dataset.petSpecies
        || pet_filter_panel?.dataset.species
        || ''
    ).toLowerCase();

    if (species) {
        return species;
    }

    const speciesId = prettyLabel(
        pet_filter_context.species_id
        || pet_filter_panel?.dataset.petSpeciesId
        || ''
    ).toLowerCase();

    if (speciesId === '1') {
        return 'dog';
    }

    if (speciesId === '2') {
        return 'cat';
    }

    if (speciesId === '1003') {
        return 'other';
    }

    return species;
}

function getPetFilterConfig() {
    const species = getPetSpeciesSlug();
    const pageType = prettyLabel(
        pet_filter_context.page_type
        || pet_filter_panel?.dataset.pageType
        || ''
    ).toLowerCase();
    const filtersDisabled = pet_filter_context.show_filters === false
        || pet_filter_context.show_filters === 'false'
        || pet_filter_panel?.dataset.showFilters === 'false'
        || pageType === 'stray'
        || window.location.pathname.includes('/lost-found/')
        || window.location.pathname.includes('/current-strays/');

    if (filtersDisabled) {
        return {
            species,
            showFilters: false,
            showSizeFilter: false,
            ageOptions: [],
            sizeOptions: [],
        };
    }

    if (species === 'cat') {
        return {
            species,
            showFilters: true,
            showSizeFilter: false,
            ageOptions: [
                { value: 'kitten', label: 'Kitten' },
                { value: 'adult', label: 'Adult' },
                { value: 'senior', label: 'Senior' },
            ],
            sizeOptions: [],
        };
    }

    if (species === 'other') {
        return {
            species,
            showFilters: false,
            showSizeFilter: false,
            ageOptions: [],
            sizeOptions: [],
        };
    }

    return {
        species: species || 'dog',
        showFilters: true,
        showSizeFilter: true,
        ageOptions: [
            { value: 'puppy', label: 'Puppy' },
            { value: 'adult', label: 'Adult' },
            { value: 'senior', label: 'Senior' },
        ],
        sizeOptions: [
            { value: 'S', label: 'S' },
            { value: 'M', label: 'M' },
            { value: 'L', label: 'L' },
            { value: 'Unknown', label: 'Unknown' },
        ],
    };
}

function getPetAgeMonths(pet) {
    const months = Number.parseInt(normalizePetValue(pet?.Age), 10);
    return Number.isFinite(months) && months >= 0 ? months : null;
}

function getPetIntakeDate(pet) {
    return normalizePetValue(pet?.LastIntakeDate);
}

function getPetSiteSourceValue(pet) {
    return normalizePetValue(pet?.Site);
}

function getPetSiteDisplayValue(pet) {
    const site = getPetSiteSourceValue(pet);

    if (!site) {
        return 'TBD';
    }

    if (site === 'Village Adoptions') {
        return 'Young-Williams Animal Village';
    }

    return site;
}

function getPetAgeBucket(pet) {
    const months = getPetAgeMonths(pet);

    if (months === null) {
        return 'unknown';
    }

    const species = getPetSpeciesSlug();

    if (species === 'other') {
        return 'unknown';
    }

    if (species === 'cat') {
        if (months < 6) {
            return 'kitten';
        }

        if (months < 84) {
            return 'adult';
        }

        return 'senior';
    }

    if (months < 6) {
        return 'puppy';
    }

    if (months < 84) {
        return 'adult';
    }

    return 'senior';
}

function getAgeBucketLabel(value) {
    const config = getPetFilterConfig();
    const option = config.ageOptions.find((entry) => entry.value === value);

    return option ? option.label : 'All Age Group';
}

function parseLastIntakeDate(value) {
    const normalized = prettyLabel(value);

    if (!normalized) {
        return Number.POSITIVE_INFINITY;
    }

    const timestamp = Date.parse(normalized.replace(' ', 'T'));
    return Number.isNaN(timestamp) ? Number.POSITIVE_INFINITY : timestamp;
}

function sortPetsByLastIntake(pets) {
    return [...pets].sort((a, b) => {
        const aDate = parseLastIntakeDate(a?.LastIntakeDate);
        const bDate = parseLastIntakeDate(b?.LastIntakeDate);

        if (aDate === bDate) {
            const aId = Number.parseInt(normalizePetValue(a?.ID), 10);
            const bId = Number.parseInt(normalizePetValue(b?.ID), 10);

            return (Number.isNaN(aId) ? 0 : aId) - (Number.isNaN(bId) ? 0 : bId);
        }

        return aDate - bDate;
    });
}

function firstPetValue(pet, keys) {
    for (const key of keys) {
        const rawValue = pet?.[key];

        if (Array.isArray(rawValue)) {
            for (const item of rawValue) {
                const normalizedItem = normalizePetValue(item);
                if (normalizedItem) {
                    return normalizedItem;
                }
            }

            continue;
        }

        const value = normalizePetValue(rawValue);
        if (value) {
            return value;
        }
    }

    return '';
}

function getPetDisplayName(pet) {
    return firstPetValue(pet, ['AnimalName', 'Name']) || 'Unknown';
}

function getPetPrimaryPhoto(pet) {
    return firstPetValue(pet, ['Photo', 'Photo1', 'Photo2', 'Photo3']);
}

function isBondedPair(pet) {
    if (Array.isArray(pet?.BuddyID)) {
        return pet.BuddyID.some((value) => {
            const normalizedValue = normalizePetValue(value);
            return normalizedValue && normalizedValue !== '0';
        });
    }

    const buddyId = normalizePetValue(pet?.BuddyID);

    if (!buddyId) {
        return false;
    }

    if (buddyId === '0') {
        return false;
    }

    const numericBuddyId = Number.parseInt(buddyId, 10);
    if (!Number.isNaN(numericBuddyId)) {
        return numericBuddyId !== 0;
    }

    return true;
}

function hydratePetRecordFromDetail(pet, detail, card = null) {
    if (!pet || !detail) {
        return pet;
    }

    const hydratedPet = {
        ...pet,
        ...detail,
        stray_or_pet: pet.stray_or_pet,
    };

    hydratedPet.Size = detail.Size ?? pet.Size ?? hydratedPet.Size;
    hydratedPet.HasBondedPair = isBondedPair(hydratedPet);
    hydratedPet.LastIntakeDate = detail.LastIntakeDate ?? pet.LastIntakeDate ?? hydratedPet.LastIntakeDate;

    if (card) {
        card.setAttribute('data-size', getPetSize(hydratedPet));
        card.setAttribute('data-bonded-pair', hydratedPet.HasBondedPair ? 'true' : 'false');
        card.setAttribute('data-intake-date', getPetIntakeDate(hydratedPet));
        card.setAttribute('data-intake-state', getPetIntakeDate(hydratedPet) ? 'persisted' : 'new');
    }

    const petIndex = Array.isArray(pet_posts)
        ? pet_posts.findIndex((item) => String(item?.ID) === String(hydratedPet.ID))
        : -1;

    if (petIndex !== -1) {
        pet_posts[petIndex] = hydratedPet;
    }

    return hydratedPet;
}

function getSelectLabel(select) {
    if (!select) {
        return 'All';
    }

    const selectedOption = select.selectedOptions?.[0];
    return selectedOption ? selectedOption.textContent.trim() : 'All';
}

function getGoodWithSummary() {
    const values = [];

    if (filter_state.goodWithDogs) {
        values.push('Dogs');
    }

    if (filter_state.goodWithCats) {
        values.push('Cats');
    }

    if (filter_state.goodWithKids) {
        values.push('Kids');
    }

    return values.length ? values.join(', ') : 'None';
}

function updateFilterButtonSummaries() {
    const ageGroupSelect = pet_filter_panel?.querySelector('[data-filter-key="ageGroup"]');
    const sizeSelect = pet_filter_panel?.querySelector('[data-filter-key="size"]');
    const locationSelect = pet_filter_panel?.querySelector('[data-filter-key="location"]');

    const summaryMap = {
        ageGroup: getSelectLabel(ageGroupSelect),
        size: getSelectLabel(sizeSelect),
        location: getSelectLabel(locationSelect),
        goodWith: getGoodWithSummary(),
    };

    Object.entries(summaryMap).forEach(([key, value]) => {
        const summary = pet_filter_panel?.querySelector(`[data-filter-summary="${key}"]`);
        if (summary) {
            summary.textContent = value;
        }
    });
}

function closeFilterPanels(exceptKey = null) {
    pet_filter_sections.forEach((section) => {
        if (!section) {
            return;
        }

        const key = section.dataset.filterPanel;
        const shouldStayOpen = exceptKey && key === exceptKey;
        section.hidden = !shouldStayOpen;

        const button = pet_filter_panel?.querySelector(`[data-filter-toggle="${key}"]`);
        if (button) {
            button.setAttribute('aria-expanded', shouldStayOpen ? 'true' : 'false');
        }
    });
}

function toggleFilterPanel(key) {
    const section = pet_filter_panel?.querySelector(`[data-filter-panel="${key}"]`);
    if (!section) {
        return;
    }

    const shouldOpen = section.hidden;
    closeFilterPanels(shouldOpen ? key : null);
}

function getPetSize(pet) {
    const size = prettyLabel(pet?.Size).toUpperCase();
    const aliases = {
        S: 'S',
        SMALL: 'S',
        M: 'M',
        MEDIUM: 'M',
        L: 'L',
        LARGE: 'L',
    };

    if (size === 'UNKNOWN') {
        return 'Unknown';
    }

    if (aliases[size]) {
        return aliases[size];
    }

    return 'Unknown';
}

function getPetCompatibilityText(pet) {
    return normalizeCompatibilityText([
        pet?.Dsc,
        pet?.Desc,
        pet?.Description,
        pet?.MemoList,
        pet?.BehaviorResult,
        pet?.BehaviorTestList,
    ]);
}

function getPetCompatibilityFlag(pet, key) {
    const compatibilitySources = [
        pet?.[key],
        pet?.CompatibilityFlags?.[key],
        pet?.compatibilityFlags?.[key],
        pet?.compatibility_flags?.[key],
    ];

    for (const source of compatibilitySources) {
        if (source === null || source === undefined || source === '') {
            continue;
        }

        if (typeof source === 'boolean') {
            return source;
        }

        if (typeof source === 'number') {
            return source > 0;
        }

        const normalized = normalizePetValue(source).toLowerCase();

        if (['y', 'yes', 'true', '1', 'on'].includes(normalized)) {
            return true;
        }

        if (['n', 'no', 'false', '0', 'off'].includes(normalized)) {
            return false;
        }
    }

    return null;
}

function textIncludesAny(text, phrases) {
    return phrases.some((phrase) => text.includes(normalizeCompatibilityText(phrase)));
}

function petHasNegativeCompatibilityText(pet, group) {
    const text = getPetCompatibilityText(pet);
    const groups = group === 'kids' ? ['kids', 'children', 'child'] : [group];
    const negativePrefixes = [
        'not good with',
        'not recommended with',
        'not compatible with',
        'no',
        'do not place with',
        'cannot live with',
        'should not live with',
        'needs home without',
        'must go to home without',
    ];
    const phrases = groups.flatMap((groupName) => negativePrefixes.map((prefix) => `${prefix} ${groupName}`));

    return textIncludesAny(text, phrases);
}

function petHasPositiveCompatibilityText(pet, group) {
    const text = getPetCompatibilityText(pet);
    const groups = group === 'kids' ? ['kids', 'children'] : [group];
    const phrases = groups.map((groupName) => `good with ${groupName}`);

    return textIncludesAny(text, phrases);
}

function petIsExplicitlyGoodWith(pet, group, negativeField) {
    const flagKey = group === 'dogs'
        ? 'goodWithDogs'
        : group === 'cats'
            ? 'goodWithCats'
            : 'goodWithKids';
    const compatibilityFlag = getPetCompatibilityFlag(pet, flagKey);

    if (compatibilityFlag !== null) {
        return compatibilityFlag;
    }

    if (isTruthyApiFlag(pet?.[negativeField])) {
        return false;
    }

    if (petHasNegativeCompatibilityText(pet, group)) {
        return false;
    }

    return petHasPositiveCompatibilityText(pet, group);
}

function petMatchesGoodWith(pet) {
    if (filter_state.goodWithDogs && !petIsExplicitlyGoodWith(pet, 'dogs', 'NoDogs')) {
        return false;
    }

    if (filter_state.goodWithCats && !petIsExplicitlyGoodWith(pet, 'cats', 'NoCats')) {
        return false;
    }

    if (filter_state.goodWithKids && !petIsExplicitlyGoodWith(pet, 'kids', 'NoKids')) {
        return false;
    }

    return true;
}

function petMatchesFilters(pet) {
    const ageGroup = getPetAgeBucket(pet);
    const size = getPetSize(pet);
    const location = getPetSiteDisplayValue(pet);

    if (filter_state.ageGroup !== 'all' && !petMatchesAgeGroup(filter_state.ageGroup, ageGroup)) {
        return false;
    }

    if (filter_state.size !== 'all' && size !== filter_state.size) {
        return false;
    }

    if (filter_state.location !== 'all' && location !== filter_state.location) {
        return false;
    }

    return petMatchesGoodWith(pet);
}

function petMatchesAgeGroup(selectedAgeGroup, petAgeGroup) {
    if (selectedAgeGroup === 'adult') {
        return petAgeGroup === 'adult' || petAgeGroup === 'senior';
    }

    return petAgeGroup === selectedAgeGroup;
}

function populateSelect(select, values, label) {
    if (!select) {
        return;
    }

    const options = [
        `<option value="all">All ${escapeHtml(label)}</option>`,
        ...values.map((value) => {
            const optionValue = typeof value === 'object' && value !== null ? value.value : value;
            const optionLabel = typeof value === 'object' && value !== null ? value.label : prettyLabel(value);

            return `<option value="${escapeHtml(optionValue)}">${escapeHtml(optionLabel)}</option>`;
        }),
    ];

    select.innerHTML = options.join('');
}

function syncFilterControls() {
    if (!pet_filter_panel) {
        return;
    }

    const selects = [...pet_filter_panel.querySelectorAll('select[data-filter-key]')];

    selects.forEach((select) => {
        const key = select.dataset.filterKey;
        if (key && key in filter_state) {
            select.value = filter_state[key];
        }
    });

    const goodWithBoxes = [...pet_filter_panel.querySelectorAll('input[data-good-with-key]')];
    goodWithBoxes.forEach((checkbox) => {
        const key = checkbox.dataset.goodWithKey;
        checkbox.checked = Boolean(filter_state[`goodWith${key.charAt(0).toUpperCase()}${key.slice(1)}`]);
    });

    updateFilterButtonSummaries();
}

function getFilteredPets() {
    if (typeof pet_posts === 'undefined' || !Array.isArray(pet_posts)) {
        return [];
    }

    return pet_posts.filter(petMatchesFilters);
}

function updateResultsMeta(filteredCount) {
    if (pet_filter_results) {
        const noun = filteredCount === 1 ? 'pet' : 'pets';
        const filter_config = getPetFilterConfig();
        const totalCount = Array.isArray(pet_posts) ? pet_posts.length : filteredCount;

        if (!filter_config.showFilters) {
            pet_filter_results.textContent = `${filteredCount} ${noun} found.`;
            return;
        }

        pet_filter_results.textContent = `${filteredCount} of ${totalCount} ${noun} match these filters.`;
    }

    if (pet_empty_state) {
        pet_empty_state.hidden = filteredCount !== 0;
    }
}

function appendPets(elements, startIndex, endIndex) {
    const petsToAdd = elements.slice(startIndex, endIndex);

    petsToAdd.forEach((pet) => {
        const elementExists = document.querySelector(`.pet-card button[id="${pet.ID}"]`);
        if (!elementExists) {
            const petCard = buildPetCard(pet);
            if (petCard) {
                pet_grid.appendChild(petCard);
            }
        }
    });
}

function destroyPetScrollLoader() {
    if (pet_scroll_loader && typeof pet_scroll_loader.destroy === 'function') {
        pet_scroll_loader.destroy();
    }
    pet_scroll_loader = null;
}

function renderFilteredPets() {
    if (!pet_grid || typeof pet_posts === 'undefined' || !Array.isArray(pet_posts)) {
        return;
    }

    filtered_pet_posts = getFilteredPets();
    pet_grid.innerHTML = '';
    destroyPetScrollLoader();
    syncFilterControls();
    updateResultsMeta(filtered_pet_posts.length);

    if (!filtered_pet_posts.length) {
        return;
    }

    appendPets(filtered_pet_posts, 0, initial_pet_batch_size);
    pet_scroll_loader = new Moxcar_Dynamic_Scroll(pet_grid, filtered_pet_posts, (elementToWatch, elements, paginationLimit, index) => {
        const minimum = index * paginationLimit;
        const maximum = (index + 1) * paginationLimit;
        appendPets(elements, minimum, maximum);
    }, pagination_batch_size);
}

function initializePetFilters() {
    if (!pet_filter_panel || typeof pet_posts === 'undefined' || !Array.isArray(pet_posts)) {
        return;
    }

    pet_posts = sortPetsByLastIntake(pet_posts);

    const filter_config = getPetFilterConfig();

    if (!filter_config.showFilters) {
        renderFilteredPets();
        return;
    }

    const ageGroupSelect = pet_filter_panel.querySelector('[data-filter-key="ageGroup"]');
    const sizeSelect = pet_filter_panel.querySelector('[data-filter-key="size"]');
    const locationSelect = pet_filter_panel.querySelector('[data-filter-key="location"]');

    populateSelect(ageGroupSelect, filter_config.ageOptions, 'Age Group');
    populateSelect(sizeSelect, filter_config.sizeOptions, 'Size');
    populateSelect(locationSelect, sortAlpha(uniqueValues(pet_posts.map((pet) => getPetSiteDisplayValue(pet)))), 'Location');

    pet_filter_panel.addEventListener('change', (event) => {
        const target = event.target;

        if (target.matches('select[data-filter-key]')) {
            const key = target.dataset.filterKey;
            filter_state[key] = target.value;
            updateFilterButtonSummaries();
            renderFilteredPets();
            return;
        }

        if (target.matches('input[data-good-with-key]')) {
            const key = target.dataset.goodWithKey;
            filter_state[`goodWith${key.charAt(0).toUpperCase()}${key.slice(1)}`] = target.checked;
            updateFilterButtonSummaries();
            renderFilteredPets();
        }
    });

    pet_filter_toggle_buttons.forEach((button) => {
        button.addEventListener('click', () => {
            const key = button.dataset.filterToggle;
            if (key) {
                toggleFilterPanel(key);
            }
        });
    });

    if (clear_filters_button) {
        clear_filters_button.addEventListener('click', () => {
            filter_state.ageGroup = 'all';
            filter_state.size = 'all';
            filter_state.location = 'all';
            filter_state.goodWithDogs = false;
            filter_state.goodWithCats = false;
            filter_state.goodWithKids = false;

            closeFilterPanels(null);
            updateFilterButtonSummaries();
            renderFilteredPets();
        });
    }

    closeFilterPanels(null);
    updateFilterButtonSummaries();
    renderFilteredPets();
}

function buildPetCard(test_pet) {
    if (!pet_card_template) {
        return null;
    }

    // Clone the template
    const clone = document.importNode(pet_card_template.content, true);
    const pet_card = clone.querySelector('.pet-card');

    if (!pet_card) {
        return null;
    }

    const pet_name = getPetDisplayName(test_pet);
    const pet_photo = getPetPrimaryPhoto(test_pet);
    const age_bucket = getPetAgeBucket(test_pet);
    const site_value = getPetSiteDisplayValue(test_pet);
    const bonded_pair = isBondedPair(test_pet);

    if (!pet_name || pet_name === 'Unknown' || !pet_photo) {
        console.warn('[young-williams] skipping incomplete pet card', {
            id: test_pet?.ID,
            name: pet_name,
            photo: pet_photo,
        });
        return null;
    }

    // Set data attributes
   pet_card.setAttribute('data-pet-spieces', test_pet.Species);
   pet_card.setAttribute('data-pet-species', test_pet.Species);
   pet_card.setAttribute('data-pet_status', test_pet.stray_or_pet);
   pet_card.setAttribute('data-pet-status', test_pet.stray_or_pet);
   pet_card.setAttribute('data-age-group', age_bucket);
   pet_card.setAttribute('data-age-bucket', age_bucket);
   pet_card.setAttribute('data-size', getPetSize(test_pet));
   pet_card.setAttribute('data-location', site_value);
   pet_card.setAttribute('data-site', site_value);
   pet_card.setAttribute('data-bonded-pair', bonded_pair ? 'true' : 'false');
   pet_card.setAttribute('data-intake-date', getPetIntakeDate(test_pet));
   pet_card.setAttribute('data-intake-state', getPetIntakeDate(test_pet) ? 'persisted' : 'new');
   pet_card.setAttribute('data-animal-api-nonce', getAnimalApiNonce());

    // Set button id (replace 'buttonId' with the actual property name of the button id in test_pet)
    const button = pet_card.querySelector('button');
    button.setAttribute('id', test_pet.ID);

    if (bonded_pair) {
        button.insertAdjacentHTML('afterbegin', '<span class="pet-card__badge pet-card__badge--bonded">Bonded Pair</span>');
    }

    // Set thumbnail image source and alt text
    const thumbnail = pet_card.querySelector('.pet-thumbnail img');
    thumbnail.setAttribute('src', pet_photo);
    thumbnail.setAttribute('alt', pet_name);

    // Set pet name
    pet_card.querySelector('.pet-name').textContent = pet_name;

    pet_card.onclick =  () => petClickHandler(pet_card);

  
    
    return pet_card;
}

if (pet_grid && typeof pet_posts !== 'undefined') {
    initializePetFilters();
}




//  // add event listener to pagination buttons
 

 

let pet_cards = document.querySelectorAll('.pet-card');

 let pet_slider_arrows = document.querySelectorAll('.animal-slide-arrow');

 
async function petClickHandler (card)  {
    let button = card.querySelector('button');
    let id = button.id;
    let pet_status  = card.dataset.pet_status
      return_element = card;
     
    try {
        // alert message
        createAlertMessage('petGrid', 'progress', 'Loading pet, please wait...', false); // Persistent alert with a custom message
        const api_url  = app.site_url + '/wp-json/animal-api/v1/load-pets';
        const animal_api_nonce = getAnimalApiNonce(card);
        console.log('[young-williams] pet click nonce', {
            id,
            pet_status,
            nonce: animal_api_nonce,
        });
        let response = await loadPetDetails(api_url, id, pet_status, animal_api_nonce);

        if (response.status === 403) {
            const refreshed_nonce = await refreshAnimalApiNonce(card);
            response = await loadPetDetails(api_url, id, pet_status, refreshed_nonce);
        }

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();
        const detail_data = data.post_data || {};

        // Assuming the API sends back a "link" property in the response
        const link = data.link;
 // Alert message of opening new page
 createAlertMessage('petGrid', 'success', 'Opening Pet Page'); // Persistent alert with a custom message


        if(!link) {
            alert('Pet not found, please select another pet.');
        }
       
    //    filter pet_posts by id
    let pet = Array.isArray(pet_posts)
        ? pet_posts.find((pet) => String(pet?.ID) === String(id))
        : null;

    if (!pet) {
        pet = {
            ID: id,
            stray_or_pet: pet_status,
        };
    }

    pet = hydratePetRecordFromDetail(pet, detail_data, card);
     
     
    
        //  petModal
        let pet_link_modal = petLinkModal(link, pet, pet.stray_or_pet);

        // attach pet link modal to body
       !document.querySelector('#pet-card')  &&  document.body.appendChild(pet_link_modal);
        // lock body scroll
        document.body.classList.add('modal-open');

    // change url without reloading page 
    window.history.pushState({id: id}, '', link);
       
      
    } catch (error) {
        console.error('Error:', error);
        // Handle the error here, e.g., display an error message to the user
    }
}
let animal_slider = [...document.querySelectorAll('.animal-layout-slide')].filter((slide) => {
    let image = slide.querySelector('img');
    let url = window.location.href;
 
    return image && image?.src && image.src !== "_" && image.src !== url;
});

 
if(animal_slider.length > 0){

 
 let anmials_slider_length = animal_slider.length;

 let currentSlide = 0;
 
 if(anmials_slider_length > 1){

 let interval  = 5000;



let timer = setInterval(() => {
    nextSlide();
}, interval)




animal_slider[currentSlide].classList.add('active');




// give first slide a class of active

 
function nextSlide(){
    animal_slider[currentSlide].classList.remove('active');
    
    currentSlide = (currentSlide + 1) % animal_slider.length;
    animal_slider[currentSlide].classList.add('active');
     
    clearInterval(timer);
    timer = setInterval(() => {
        nextSlide();
    }, interval)
}



 function prevSlide(){
    animal_slider[currentSlide].classList.remove('active');
    
    currentSlide = (currentSlide - 1) % animal_slider.length;
        // if current slide is less than 0, set it to the last slide
        if(currentSlide < 0){
            currentSlide = animal_slider.length - 1;
        }
    animal_slider[currentSlide].classList.add('active');

    clearInterval(timer);
    timer = setInterval(() => {
        nextSlide();
    }, interval)
 }

//  loop through each arrow and add event listener
pet_slider_arrows.forEach((arrow) => {
    arrow.addEventListener('click', () => {
        arrow = arrow.closest('.animal-slide-arrow');
        // clear the interval  
 
        if(arrow.id.includes('forward')){
            nextSlide();
        } else {
            prevSlide();
        }
    });

    // reset the interval
   
});



 } else {
    animal_slider[currentSlide].classList.add('active');
 
 pet_slider_arrows.forEach((arrow) => {
    arrow.remove();
    // b
 });    

 }

}


 function createAlertMessage(id, state, message, persistent = false) {
    // find current alert message and remove it
    const currentAlert = document.querySelector(`.alert-message`);

    if (currentAlert) {
        currentAlert.remove();
        }

    const alertDiv = document.createElement('div');
    alertDiv.className = `alert-message ${state}`;
    alertDiv.innerHTML = `<p>${message}</p>`;
  
    // Find the element with the specified ID
    const targetElement = document.getElementById(id);
  
    if (targetElement) {
      // Insert the alert message after the target element
      targetElement.parentNode.insertBefore(alertDiv, targetElement.nextSibling);
  
      // Add the "show" class immediately after adding the element
      alertDiv.classList.add('show');
  
      if (!persistent) {
        // Remove the alert message after 5 seconds
        setTimeout(() => {
          alertDiv.classList.remove('show');
          setTimeout(() => {
            alertDiv.remove();
          }, 500); // Delay removal to allow for transition effect (if any)
        }, 5000);
      }
    } else {
      console.error(`Element with ID ${id} not found.`);
    }
  }
 

  

  function petLinkModal(link, pet, stray_or_pet){
  let pet_link_modal = document.createElement('div');
  pet_link_modal.id =  'pet-card';
  pet_link_modal.setAttribute('data-strayOrPet', stray_or_pet);
  pet_link_modal.setAttribute('data-pageUrl', link);
  pet_link_modal.setAttribute('data-species', pet?.Species);
  pet_link_modal.setAttribute('data-bonded-pair', isBondedPair(pet) ? 'true' : 'false');
  pet_link_modal.classList.add('pet-link-modal');
    pet_link_modal.addEventListener('click', function(e){
      let target = e.target;
  
 
        
  
    
      if(target.classList.contains('pet-link-modal'))  {
        pet_link_modal.remove();
         //   unlock body scroll
    document.body.classList.remove('modal-open');
        //   scroll to pet card
        return_element.scrollIntoView({behavior: 'smooth', block: 'start'});
          //   have url change back to original url when modal is closed
          window.history.pushState({id: pet.ID}, '', current_url);
      }
     
   


  
 
    });
   let encoded_link = encodeURI(link);
    const Species = pet?.Species;
    const bonded_pair = isBondedPair(pet);
    const bonded_badge = bonded_pair ? '<span class="pet-single-card__badge pet-single-card__badge--bonded">Bonded Pair</span>' : '';

     const stray_or_pet_class = stray_or_pet == 'pet' ? 'pet-single-card-pet' : 'pet-single-card-stray';
      let pet_details = [
        {
            label: 'Breed',
            property: 'PrimaryBreed',
            pet_type: 'both'
        },
        {
            label: 'Age',
            property: 'Age',
            pet_type: 'both'
        }, 
        {
            label: 'Size',
            property: 'Size',
            pet_type: 'both'

        }, 
        {
            label: 'Color',
            property: 'PrimaryColor',
            pet_type: 'stray'
        },
       
        {
            label: "Sex", 
             property: "Sex",
               pet_type: 'both'
             
           }, 
        {
            label: 'Found Date',
            property: 'FoundDate',
            pet_type: 'stray'
        
        }, 
        {
            label: 'Found Location',
            property: 'FoundLocation',
            pet_type: 'stray'
        }, 
        {
            label: "City/State", 
            property: "CityState",
            pet_type: 'stray'
        },
       
        {
            label: "Weight",
            property: "BodyWeight",
            pet_type: 'both'
        }, 
        {
            label: "Site",
            property: "Site",
            pet_type: 'stray'
        }, 
      
        {
            label: "Apply",
            property: "Site",
            pet_type: 'pet'
        },
      
      ]
    let logos  = `
    <div class="x-col e17592-e49 mdko-g mdko-i">
        <div class="x-text x-content e17592-e50 mdko-14">
            <div class="heateor_sss_sharing_container heateor_sss_horizontal_sharing" data-heateor-ss-offset="0" data-heateor-sss-href="${link}">
                <div class="heateor_sss_sharing_ul">
                    <a aria-label="Facebook" class="heateor_sss_facebook" href="https://www.facebook.com/sharer/sharer.php?u=${encoded_link}" title="Facebook" rel="nofollow noopener" target="_blank" style="font-size:32px!important;box-shadow:none;display:inline-block;vertical-align:middle" data-feathr-click-track="true" data-feathr-link-aids="617844865cc52155a7987c13">
                        <span class="heateor_sss_svg" style="background-color:#3c589a;width:35px;height:35px;border-radius:999px;display:inline-block;opacity:1;float:left;font-size:32px;box-shadow:none;display:inline-block;font-size:16px;padding:0 4px;vertical-align:middle;background-repeat:repeat;overflow:hidden;padding:0;cursor:pointer;box-sizing:content-box">
                            <svg style="display:block;border-radius:999px;" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="-5 -5 42 42">
                                <path d="M17.78 27.5V17.008h3.522l.527-4.09h-4.05v-2.61c0-1.182.33-1.99 2.023-1.99h2.166V4.66c-.375-.05-1.66-.16-3.155-.16-3.123 0-5.26 1.905-5.26 5.405v3.016h-3.53v4.09h3.53V27.5h4.223z" fill="#fff"></path>
                            </svg>
                        </span>
                    </a>
                    <a aria-label="Twitter" class="heateor_sss_button_x" href="https://twitter.com/intent/tweet?text=54850366&amp;url=${encoded_link}" title="Twitter" rel="nofollow noopener" target="_blank" style="font-size:32px!important;box-shadow:none;display:inline-block;vertical-align:middle" data-feathr-click-track="true" data-feathr-link-aids="617844865cc52155a7987c13">
                        <span class="heateor_sss_svg heateor_sss_s__default heateor_sss_s_x" style="background-color:#2a2a2a;width:35px;height:35px;border-radius:999px;display:inline-block;opacity:1;float:left;font-size:32px;box-shadow:none;display:inline-block;font-size:16px;padding:0 4px;vertical-align:middle;background-repeat:repeat;overflow:hidden;padding:0;cursor:pointer;box-sizing:content-box">
                            <svg width="100%" height="100%" style="display:block;border-radius:999px;" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                                <path fill="#fff" d="M21.751 7h3.067l-6.7 7.658L26 25.078h-6.172l-4.833-6.32-5.531 6.32h-3.07l7.167-8.19L6 7h6.328l4.37 5.777L21.75 7Zm-1.076 16.242h1.7L11.404 8.74H9.58l11.094 14.503Z"></path>
                            </svg>
                        </span>
                    </a>
                    <a aria-label="Copy Link" class="heateor_sss_button_copy_link" title="Copy Link" rel="nofollow noopener" href="${link}" onclick="event.preventDefault()" style="font-size:32px!important;box-shadow:none;display:inline-block;vertical-align:middle" data-feathr-click-track="true" data-feathr-link-aids="617844865cc52155a7987c13">
                        <span class="heateor_sss_svg heateor_sss_s__default heateor_sss_s_copy_link" style="background-color:#ffc112;width:35px;height:35px;border-radius:999px;display:inline-block;opacity:1;float:left;font-size:32px;box-shadow:none;display:inline-block;font-size:16px;padding:0 4px;vertical-align:middle;background-repeat:repeat;overflow:hidden;padding:0;cursor:pointer;box-sizing:content-box">
                            <svg style="display:block;border-radius:999px;" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="-4 -4 40 40">
                                <path fill="#fff" d="M24.412 21.177c0-.36-.126-.665-.377-.917l-2.804-2.804a1.235 1.235 0 0 0-.913-.378c-.377 0-.7.144-.97.43.026.028.11.11.255.25.144.14.24.236.29.29s.117.14.2.256c.087.117.146.232.177.344.03.112.046.236.046.37 0 .36-.126.666-.377.918a1.25 1.25 0 0 1-.918.377 1.4 1.4 0 0 1-.373-.047 1.062 1.062 0 0 1-.345-.175 2.268 2.268 0 0 1-.256-.2 6.815 6.815 0 0 1-.29-.29c-.14-.142-.223-.23-.25-.254-.297.28-.445.607-.445.984 0 .36.126.664.377.916l2.778 2.79c.243.243.548.364.917.364.36 0 .665-.118.917-.35l1.982-1.97c.252-.25.378-.55.378-.9zm-9.477-9.504c0-.36-.126-.665-.377-.917l-2.777-2.79a1.235 1.235 0 0 0-.913-.378c-.35 0-.656.12-.917.364L7.967 9.92c-.254.252-.38.553-.38.903 0 .36.126.665.38.917l2.802 2.804c.242.243.547.364.916.364.377 0 .7-.14.97-.418-.026-.027-.11-.11-.255-.25s-.24-.235-.29-.29a2.675 2.675 0 0 1-.2-.255 1.052 1.052 0 0 1-.176-.344 1.396 1.396 0 0 1-.047-.37c0-.36.126-.662.377-.914.252-.252.557-.377.917-.377.136 0 .26.015.37.046.114.03.23.09.346.175.117.085.202.153.256.2.054.05.15.148.29.29.14.146.222.23.25.258.294-.278.442-.606.442-.983zM27 21.177c0 1.078-.382 1.99-1.146 2.736l-1.982 1.968c-.745.75-1.658 1.12-2.736 1.12-1.087 0-2.004-.38-2.75-1.143l-2.777-2.79c-.75-.747-1.12-1.66-1.12-2.737 0-1.106.392-2.046 1.183-2.818l-1.186-1.185c-.774.79-1.708 1.186-2.805 1.186-1.078 0-1.995-.376-2.75-1.13l-2.803-2.81C5.377 12.82 5 11.903 5 10.826c0-1.08.382-1.993 1.146-2.738L8.128 6.12C8.873 5.372 9.785 5 10.864 5c1.087 0 2.004.382 2.75 1.146l2.777 2.79c.75.747 1.12 1.66 1.12 2.737 0 1.105-.392 2.045-1.183 2.817l1.186 1.186c.774-.79 1.708-1.186 2.805-1.186 1.078 0 1.995.377 2.75 1.132l2.804 2.804c.754.755 1.13 1.672 1.13 2.75z"></path>
                            </svg>
                        </span>
                    </a>
                    <!-- Add other social media links as needed -->
                    <span style="
                    margin-left: .5rem;
                    font-weight: 800;
                    text-transform: uppercase;
                "> - Share Me!</span>
                </div>
                <div class="heateorSssClear"></div>
            </div>
        </div>
    </div>
`;
      
      let mobileLink;

       let isAdoptUrl =true;
      

      let mobileAddress;
      if (pet?.FoundLocation && pet?.City && pet?.State) {
          mobileAddress = `${pet?.FoundLocation}, ${pet?.City || ''}, ${pet?.State || ''}`;
      }
      
     
      
    
 
      const site_source_value = getPetSiteSourceValue(pet);
      const site_value = site_source_value || 'TBD';

      if (site_value == 'Foster Care') {
        
          mobileLink = `<a 
           target="_blank"   
          class="foster-care-application " href="https://forms.office.com/pages/responsepage.aspx?id=lG6t1wiPMEOW0_cy63ksOavVvhPTfJlJqzEbUu7umO5UN1RMMUZLOFU4Wks4T1E2RlFPTkdUMVhIUi4u" data-feathr-click-track="true" data-feathr-link-aids="617844865cc52155a7987c13" style="
text-align: center;
display: block;
"> Click To Apply </a>`;
      } else {
          // if pet is at Young-Williams Animal Center or Young-Williams Animal Village, then use the apply link
            let adoption_location = site_source_value == "Village Adoptions" ? "Young-Williams Animal Village" : site_source_value || "Young-Williams Animal Center";
           
            mobileLink = `<span>Apply @ ${adoption_location}</span>`;
            
            }

      
      if (pet?.FoundLocation) isAdoptUrl = false;
             
    pet_link_modal.innerHTML = `
    <div  class="pet-single-card">
        <div class="pet-single-card-column">
        ${isAdoptUrl ? `
         <div class="mobile-apply">
            ${ mobileLink}
            </div>
        ` : ''}
       
       <div class="pet-single-card-slider">
       <div class="x-row-inner" style="
    height: 100%;
 
    width: 100%;
    z-index: 9999999999;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
"><div class="x-col e17592-e11 mdko-g mdko- j" style="
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 2rem;
    color: #22395b;
">


  
<div class="x-div e17592-e12 mdko-l mdko-n animal-slide-arrow" id="backward"><i class="x-icon e17592-e13 mdko-p" aria-hidden="true" data-x-icon-s=""></i></div><div class="x-div e17592-e14 mdko-l mdko-n animal-slide-arrow" id="forward"><i class="x-icon e17592-e15 mdko-p" aria-hidden="true" data-x-icon-s=""></i></div></div></div>
       ${
        pet?.Photo && !Array.isArray(pet?.Photo) ? `
       <div class="pet-single-card-slide">
        <img src="${pet?.Photo}" alt="${pet?.AnimalName}" />
     </div> `: ""}

        ${
        pet?.Photo1 && !Array.isArray(pet?.Photo1) ? `
         <div class="pet-single-card-slide">
            <img src="${pet?.Photo1  }" alt="${pet?.AnimalName}" />
        </div> `: ""}
        ${
        pet?.Photo2  && !Array.isArray(pet?.Photo2)? `
            <div class="pet-single-card-slide">
                <img src="${pet?.Photo2  }" alt="${pet?.AnimalName}" />
            </div> `: ""}
        ${pet?.Photo3 && !Array.isArray(pet?.Photo3) ? `
            <div class="pet-single-card-slide">
                <img src="${pet?.Photo3  }" alt="${pet?.AnimalName}" />
            </div> `: ""}


      
         
       </div>
       </div>
       <div class="pet-single-card-column">
        <h2>
            <span class="pet-single-card__title">
                <span class="pet-single-card__title-name">
                    ${pet.AnimalName || pet.Name}
                    ${bonded_badge}
                </span>
                <span class="pet-single-card__animal-id">
                    Animal ID : ${escapeHtml(pet?.ID)}
                </span>
            </span>

            <span id="close_modal" class="closodal" >
                X
            </span>
        </h2>
        ${mobileAddress != undefined ? `
        <div class="mobile-location">
         Found Location: <br /> ${mobileAddress}
        </div>
        ` : ''}
        ${ pet?.Dsc && !Array.isArray(pet?.Dsc) ? 
        `<div class="pet-single-card-description">
            <p style="display:inline-block; margin: 1rem 0 !important;" id="pet-description" data-short=""  >${ pet.Dsc }  </p>  
        </div>` : ""}
        <div class="pet-single-data ${stray_or_pet_class}">
            ${generatePetDetails(stray_or_pet, stray_or_pet_class, pet, pet_details)}
                 
           </div>
           ${logos}
         
       </div>
       
       <div> 
       ${stray_or_pet == 'pet' ? `
       <p><i>For animals located at Young-Williams Animal Center or Young-Williams Animal Village, please apply </i><b><i>in person</i></b><i>. <span>For animals currently in foster care, please apply </span><a href="https://forms.office.com/pages/responsepage.aspx?id=lG6t1wiPMEOW0_cy63ksOavVvhPTfJlJqzEbUu7umO5UN1RMMUZLOFU4Wks4T1E2RlFPTkdUMVhIUi4u" target="_blank" rel="noopener" data-feathr-click-track="true" data-feathr-link-aids="[&quot;617844865cc52155a7987c13&quot;],617844865cc52155a7987c13"><span>here</span></a><span> to schedule a meet-and-greet with the foster parent. </span>Responses from the foster may take up to 5-7 business days. </i><b><i>Please note: Application does not place animals on hold or guarantee approval for adoption.</i></b></p>
       <p><i><a class="young-williiams-adopt-button" style="margin-right: 3px;" href="https://young-williams-production.local/adopt/" data-feathr-click-track="true" data-feathr-link-aids="[&quot;617844865cc52155a7987c13&quot;]">Click here</a></i><i> for general information about the adoption process and options!</i></p>
      </div>` : ``}
    </div> 
</div> `;

  


 

let close_modal = pet_link_modal.querySelector('#close_modal');
close_modal.addEventListener('click', () => {
    pet_link_modal.remove();
    // unlock body scroll
    document.body.classList.remove('modal-open');
    // scroll to pet card
    return_element.scrollIntoView({behavior: 'smooth', block: 'start'});
}
);

let pet_single_card_sliders = [...pet_link_modal.querySelectorAll('.pet-single-card-slide')].map((slide, index) => {
    slide.dataset.slide = index;
    return slide;
});
let animal_slide_arrows = [...pet_link_modal.querySelectorAll('.animal-slide-arrow')];
 let forward_arrow = animal_slide_arrows.filter((arrow) => {
        return arrow.id.includes('forward');
    }
);
let backward_arrow = animal_slide_arrows.filter((arrow) => {
        return arrow.id.includes('backward');
    }
);


//   first slider is active
pet_single_card_sliders[0].classList.add('active');

// add event listener to forward arrow using dataset.slide of each slide 
forward_arrow[0].addEventListener('click', () => {
    let active_slide = pet_link_modal.querySelector('.pet-single-card-slide.active');
    let active_slide_index = active_slide.dataset.slide;
    let next_slide_index = parseInt(active_slide_index) + 1;
    let next_slide = pet_link_modal.querySelector(`.pet-single-card-slide[data-slide="${next_slide_index}"]`);
    if(next_slide){
        active_slide.classList.remove('active');
        next_slide.classList.add('active');
    }
});

// add event listener to backward arrow using dataset.slide of each slide
backward_arrow[0].addEventListener('click', () => {
    let active_slide = pet_link_modal.querySelector('.pet-single-card-slide.active');
    let active_slide_index = active_slide.dataset.slide;
    let prev_slide_index = parseInt(active_slide_index) - 1;
    let prev_slide = pet_link_modal.querySelector(`.pet-single-card-slide[data-slide="${prev_slide_index}"]`);
    if(prev_slide){
        active_slide.classList.remove('active');
        prev_slide.classList.add('active');
    }
});
 
 
 

return pet_link_modal;
  }


  function petLinksMonthsToString(months) {
  
    // Convert the input to an integer
    months = parseInt(months);
   
    if (months === 0) {
        return "No estimated age at this time";
    }
 
    

    // Handle the conversion logic
    if (months < 10) {
        return `${months} month${months !== 1 ? 's' : ''}`; // Pluralize if necessary
    } else if (months < 12) {
        return "1 year";
    } else {
        let years = Math.floor(months / 12); // Calculate the number of years
        let remainder = months % 12; // Calculate the remainder months

        // Check if closer to the previous year
        if (remainder <= 5) {
            return `${years} year${years !== 1 ? 's' : ''}`; // Round down
        } else {
            return `${++years} year${years !== 1 ? 's' : ''}`; // Round up
        }
    }
}

function trim_content(content, length){

 
    //  break content into array of words
    let content_array = content.split(' ');
    //  get first 10 words
    let trimmed_content = content_array.slice(0, length);
    //  join words back together
    trimmed_content = trimmed_content.join(' ');
    //  add ellipsis
    trimmed_content = trimmed_content + '...';
    // create read more button 
    let read_more_button = document.createElement('button');
    read_more_button.classList.add('read-more-button');
    read_more_button.textContent = 'Read More';
    // add event listener to read more button
     

    return trimmed_content;
}

 
function generatePetDetails(stray_or_pet, stray_or_pet_class, pet, details) {
    const petDetails = [];
    const site_source_value = getPetSiteSourceValue(pet);
    const site_value = site_source_value || 'TBD';
 
        details.forEach(detail => {
            let pet_type_detail = detail.pet_type;
            let value = pet[detail.property];
            if(detail.property == 'Age'){
                value = petLinksMonthsToString(value);
            } else if (detail.property == 'Site') {
                value = site_value;
            } else if ( detail.property == 'CityState'){
                let city = pet.City ? Array.isArray(pet.City) ? "" :  pet.City : "";
                let state = pet.State ? Array.isArray(pet.State) ? "" :  pet.State : "";
                let cityState;
                 if(city && state){
                    cityState = city + ', ' + state;
                 } else if(city && !state){
                    cityState = city;
                 } else if(!city && state){
                    cityState = state;
                 }
              value = cityState;
            }

            let detailClassName = detail.label.toLowerCase().replace(' ', '-').replace("/", "-");
             if(detail.label == 'Apply'){ 
                 if(site_value == 'Foster Care') {
                    value = `<a class="foster-care-application" href="https://forms.office.com/pages/responsepage.aspx?id=lG6t1wiPMEOW0_cy63ksOavVvhPTfJlJqzEbUu7umO5UN1RMMUZLOFU4Wks4T1E2RlFPTkdUMVhIUi4u" data-feathr-click-track="true" data-feathr-link-aids="617844865cc52155a7987c13" style="
    text-align: center;
    display: block;
">Adopt from Foster Care</a>`;
            
                    petDetails.push(`
                     <div class="pet-single-data-column ${stray_or_pet_class} 
                    ${detailClassName}
                     ">
                            <h4>${detail.label}:</h4>
                            ${value}
                        </div>

                    `);
                        
                 } else {
                     let adoption_location = site_source_value == "Village Adoptions" ? "Young-Williams Animal Village" : site_source_value || "Young-Williams Animal Center";
                    petDetails.push(`
                    <div class="pet-single-data-column ${stray_or_pet_class}
                    ${detailClassName}
                    ">
                        <h4>${detail.label}:</h4>
                        <span>${adoption_location}</span>
                    </div>

                    `);

                 }
          
             }
             
            if((pet_type_detail == 'both' || pet_type_detail == stray_or_pet) && detail.label != 'Apply'){
            petDetails.push(`
                <div class="pet-single-data-column ${stray_or_pet_class}  
                ${detailClassName}
                ">
                    <h4>${detail.label}:</h4>
                    <span>${ value }</span>
                </div>
            `);
            }
        });
     

    return petDetails.join('');
}



 

const petModalVersion2 = () => {
    return html`
        <div class="pet-link-modal-2-overlay">
            <div class="pet-link-modal-2 desktop">
                <div class="mobile-apply">
                    <a href="https://example.com/apply" class="apply-link">Apply Here</a>
                </div>
                <div class="content-container"> 
                <div class="pet-link-modal-2-slider">
                    <img class="pet-link-modal-2-slide active" src="https://picsum.photos/1600/800" alt="Random slide 1" />
                    <img class="pet-link-modal-2-slide" src="https://picsum.photos/1600/801" alt="Random slide 2" />
                    <img class="pet-link-modal-2-slide" src="https://picsum.photos/1600/802" alt="Random Image 3" />
                     <div class="arrows">
                        <div 
                         id="pet-link-modal-2-backward"
                         class="left-arrow arrow">
                            <svg fill="#000000" width="800px" height="800px" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" id="arrow">
                                <path d="M8.29289 2.29289C8.68342 1.90237 9.31658 1.90237 9.70711 2.29289L14.2071 6.79289C14.5976 7.18342 14.5976 7.81658 14.2071 8.20711L9.70711 12.7071C9.31658 13.0976 8.68342 13.0976 8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L11 8.5H1.5C0.947715 8.5 0.5 8.05228 0.5 7.5C0.5 6.94772 0.947715 6.5 1.5 6.5H11L8.29289 3.70711C7.90237 3.31658 7.90237 2.68342 8.29289 2.29289Z"/>
                              </svg>
                        </div>

                        <div 
                        id="pet-link-modal-2-forward"
                        class="right-arrow arrow">
                           <svg fill="#000000" width="800px" height="800px" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" id="arrow">
                               <path d="M8.29289 2.29289C8.68342 1.90237 9.31658 1.90237 9.70711 2.29289L14.2071 6.79289C14.5976 7.18342 14.5976 7.81658 14.2071 8.20711L9.70711 12.7071C9.31658 13.0976 8.68342 13.0976 8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L11 8.5H1.5C0.947715 8.5 0.5 8.05228 0.5 7.5C0.5 6.94772 0.947715 6.5 1.5 6.5H11L8.29289 3.70711C7.90237 3.31658 7.90237 2.68342 8.29289 2.29289Z"/>
                             </svg>
                       </div>




                     </div>

                     
                </div>
                <div class="heateor_sss_sharing_container heateor_sss_horizontal_sharing" data-heateor-ss-offset="0" data-heateor-sss-href="https://www.young-williams.org/animal/bella-15/">
                    <div class="heateor_sss_sharing_ul">
                        <a aria-label="Facebook" class="heateor_sss_facebook" href="https://www.facebook.com/sharer/sharer.php?u=https://www.young-williams.org/animal/bella-15/" title="Facebook" rel="nofollow noopener" target="_blank" style="font-size:32px!important;box-shadow:none;display:inline-block;vertical-align:middle" data-feathr-click-track="true" data-feathr-link-aids="617844865cc52155a7987c13">
                            <span class="heateor_sss_svg" style="background-color:#3c589a;width:35px;height:35px;border-radius:999px;display:inline-block;opacity:1;float:left;font-size:32px;box-shadow:none;display:inline-block;font-size:16px;padding:0 4px;vertical-align:middle;background-repeat:repeat;overflow:hidden;padding:0;cursor:pointer;box-sizing:content-box">
                                <svg style="display:block;border-radius:999px;" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="-5 -5 42 42">
                                    <path d="M17.78 27.5V17.008h3.522l.527-4.09h-4.05v-2.61c0-1.182.33-1.99 2.023-1.99h2.166V4.66c-.375-.05-1.66-.16-3.155-.16-3.123 0-5.26 1.905-5.26 5.405v3.016h-3.53v4.09h3.53V27.5h4.223z" fill="#fff"></path>
                                </svg>
                            </span>
                        </a>
                        <a aria-label="Twitter" class="heateor_sss_button_x" href="https://twitter.com/intent/tweet?text=54850366&amp;url=https://www.young-williams.org/animal/bella-15/" title="Twitter" rel="nofollow noopener" target="_blank" style="font-size:32px!important;box-shadow:none;display:inline-block;vertical-align:middle" data-feathr-click-track="true" data-feathr-link-aids="617844865cc52155a7987c13">
                            <span class="heateor_sss_svg heateor_sss_s__default heateor_sss_s_x" style="background-color:#2a2a2a;width:35px;height:35px;border-radius:999px;display:inline-block;opacity:1;float:left;font-size:32px;box-shadow:none;display:inline-block;font-size:16px;padding:0 4px;vertical-align:middle;background-repeat:repeat;overflow:hidden;padding:0;cursor:pointer;box-sizing:content-box">
                                <svg width="100%" height="100%" style="display:block;border-radius:999px;" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                                    <path fill="#fff" d="M21.751 7h3.067l-6.7 7.658L26 25.078h-6.172l-4.833-6.32-5.531 6.32h-3.07l7.167-8.19L6 7h6.328l4.37 5.777L21.75 7Zm-1.076 16.242h1.7L11.404 8.74H9.58l11.094 14.503Z"></path>
                                </svg>
                            </span>
                        </a>
                        <a aria-label="Copy Link" class="heateor_sss_button_copy_link" title="Copy Link" rel="nofollow noopener" href="https://www.young-williams.org/animal/bella-15/" onclick="event.preventDefault()" style="font-size:32px!important;box-shadow:none;display:inline-block;vertical-align:middle" data-feathr-click-track="true" data-feathr-link-aids="617844865cc52155a7987c13">
                            <span class="heateor_sss_svg heateor_sss_s__default heateor_sss_s_copy_link" style="background-color:#ffc112;width:35px;height:35px;border-radius:999px;display:inline-block;opacity:1;float:left;font-size:32px;box-shadow:none;display:inline-block;font-size:16px;padding:0 4px;vertical-align:middle;background-repeat:repeat;overflow:hidden;padding:0;cursor:pointer;box-sizing:content-box">
                                <svg style="display:block;border-radius:999px;" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="-4 -4 40 40">
                                    <path fill="#fff" d="M24.412 21.177c0-.36-.126-.665-.377-.917l-2.804-2.804a1.235 1.235 0 0 0-.913-.378c-.377 0-.7.144-.97.43.026.028.11.11.255.25.144.14.24.236.29.29s.117.14.2.256c.087.117.146.232.177.344.03.112.046.236.046.37 0 .36-.126.666-.377.918a1.25 1.25 0 0 1-.918.377 1.4 1.4 0 0 1-.373-.047 1.062 1.062 0 0 1-.345-.175 2.268 2.268 0 0 1-.256-.2 6.815 6.815 0 0 1-.29-.29c-.14-.142-.223-.23-.25-.254-.297.28-.445.607-.445.984 0 .36.126.664.377.916l2.778 2.79c.243.243.548.364.917.364.36 0 .665-.118.917-.35l1.982-1.97c.252-.25.378-.55.378-.9zm-9.477-9.504c0-.36-.126-.665-.377-.917l-2.777-2.79a1.235 1.235 0 0 0-.913-.378c-.35 0-.656.12-.917.364L7.967 9.92c-.254.252-.38.553-.38.903 0 .36.126.665.38.917l2.802 2.804c.242.243.547.364.916.364.377 0 .7-.14.97-.418-.026-.027-.11-.11-.255-.25s-.24-.235-.29-.29a2.675 2.675 0 0 1-.2-.255 1.052 1.052 0 0 1-.176-.344 1.396 1.396 0 0 1-.047-.37c0-.36.126-.662.377-.914.252-.252.557-.377.917-.377.136 0 .26.015.37.046.114.03.23.09.346.175.117.085.202.153.256.2.054.05.15.148.29.29.14.146.222.23.25.258.294-.278.442-.606.442-.983zM27 21.177c0 1.078-.382 1.99-1.146 2.736l-1.982 1.968c-.745.75-1.658 1.12-2.736 1.12-1.087 0-2.004-.38-2.75-1.143l-2.777-2.79c-.75-.747-1.12-1.66-1.12-2.737 0-1.106.392-2.046 1.183-2.818l-1.186-1.185c-.774.79-1.708 1.186-2.805 1.186-1.078 0-1.995-.376-2.75-1.13l-2.803-2.81C5.377 12.82 5 11.903 5 10.826c0-1.08.382-1.993 1.146-2.738L8.128 6.12C8.873 5.372 9.785 5 10.864 5c1.087 0 2.004.382 2.75 1.146l2.777 2.79c.75.747 1.12 1.66 1.12 2.737 0 1.105-.392 2.045-1.183 2.817l1.186 1.186c.774-.79 1.708-1.186 2.805-1.186 1.078 0 1.995.377 2.75 1.132l2.804 2.804c.754.755 1.13 1.672 1.13 2.75z"></path>
                                </svg>
                            </span>
                        </a>
                        <span style="margin-left:.5rem;font-weight:800;text-transform:uppercase;"> - Share Me!</span>
                    </div>
                </div>
                <div class="pet-link-modal-2-content">
                    <h2>Snack
                        <span id="close_modal" class="close-modal">X</span>
                    </h2>

                    <div class="pet-single-data">
                        <div class="pet-single-data-column">
                            <h4>Breed:</h4>
                            <span>Golden Retriever</span>
                        </div>
                        <div class="pet-single-data-column">
                            <h4>Age:</h4>
                            <span>2 years</span>
                        </div>
                        <div class="pet-single-data-column">
                            <h4>Sex:</h4>
                            <span>Male</span>
                        </div>
                        <div class="pet-single-data-column">
                            <h4>Weight:</h4>
                            <span>30 lbs</span>
                        </div>
                        <div class="pet-single-data-column apply">
                            <h4>Apply:</h4>
                            <a href="https://example.com/apply" class="apply-link">Apply Here</a>
                        </div>
                    </div>

                </div>
            </div>

                <div class="adoption-statement"> 
       
                    <p><i>For animals located at Young-Williams Animal Center or Young-Williams Animal Village, please apply </i><b><i>in person</i></b><i>. For animals currently in a foster home, please click the link to schedule a meet and greet. Responses from foster may take up to 5-7 business days. </i><b><i>Please note: Application does not place animals on hold or guarantee approval for adoption.</i></b></p>
                     <p><i>&nbsp;</i><i><a class="young-williiams-adopt-button" style="margin-right: 3px;" href="https://www.young-williams.org/adopt/" data-feathr-click-track="true" data-feathr-link-aids="[&quot;617844865cc52155a7987c13&quot;],617844865cc52155a7987c13">Click here</a></i><i>&nbsp;for general information about the adoption process and options!</i></p>
                   </div>
            </div>
        </div>
    `;
};
